import styled from 'styled-components';

const PeopleTableWrapper = styled.div`
	/* border: 1px solid red; //! this is for development only take it out in production */

	margin: 5px 0px;
`;

export { PeopleTableWrapper };
